module.exports = __webpack_public_path__ + "img/main-site.acee1fae.svg";